/* eslint-disable */
import { Injectable } from "@angular/core";
import * as CryptoJS from "crypto-js";
import { environment } from "@environments/environment";

@Injectable({
  providedIn: "root",
})
export class LocalService {
  key = environment.storageKey;

  public setData(key: string, value: any) {
    if (value == null) return;
    if (typeof value === "object") {
      localStorage.setItem(key, JSON.stringify(value));
    } else {
      localStorage.setItem(key, value);
    }
  }

  public getData(key: string) {
    if (!localStorage.getItem(key)) {
      return null;
    }
    const data: any = localStorage.getItem(key);
    try {
      return JSON.parse(data);
    } catch (e) {
      return data;
    }
  }

  public removeData(key: string) {
    localStorage.removeItem(key);
  }

  public clear() {
    localStorage.clear();
  }
}
